"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_TO_SUPPORTED_REGIONS_MAPPING = exports.storeCountryToCurrencyCodeMapGenerated = exports.ISO2_CURRENCY_FORMATTER_MAPPING = exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED = exports.ISO_ISO2_MAPPING = exports.ISO2_ISO_MAPPING = exports.countryCodeToIsoCountryCodeMap = exports.MoneyFormatLocale = exports.IsoCountryCodeToCurrencyNameMap = exports.IsoCountryCode2Char = exports.IsoCountryCode = exports.CountryCodeToCurrencyNameMap = void 0;
const money_1 = require("../../utils/money");
const brand_1 = require("../brand");
/**
 * Mapping from ISO 3166-1 alpha-2 country code to currency code
 */
var CountryCodeToCurrencyNameMap;
(function (CountryCodeToCurrencyNameMap) {
    /**
     * Antarctica (Dollar)
     */
    CountryCodeToCurrencyNameMap["AQ"] = "USD";
    /**
     * Austria (Euro)
     */
    CountryCodeToCurrencyNameMap["AT"] = "EUR";
    /**
     * Canada (Dollar)
     */
    CountryCodeToCurrencyNameMap["CA"] = "CAD";
    /**
     * Switzerland (Franc)
     */
    CountryCodeToCurrencyNameMap["CH"] = "CHF";
    /**
     * Czech Republic (Koruna)
     */
    CountryCodeToCurrencyNameMap["CZ"] = "CZK";
    /**
     * Germany (Euro)
     */
    CountryCodeToCurrencyNameMap["DE"] = "EUR";
    /**
     * Spain (Euro)
     */
    CountryCodeToCurrencyNameMap["ES"] = "EUR";
    /**
     * France (Euro)
     */
    CountryCodeToCurrencyNameMap["FR"] = "EUR";
    /**
     * United Kingdom (Pound)
     */
    CountryCodeToCurrencyNameMap["GB"] = "GBP";
    /**
     * Indonesia (Rupiah)
     */
    CountryCodeToCurrencyNameMap["ID"] = "IDR";
    /**
     * Japan (Yen)
     */
    CountryCodeToCurrencyNameMap["JP"] = "JPY";
    /**
     * South Korea (Won)
     */
    CountryCodeToCurrencyNameMap["KR"] = "KRW";
    /**
     * Malaysia (Ringgit)
     */
    CountryCodeToCurrencyNameMap["MY"] = "MYR";
    /**
     * Netherlands (Euro)
     */
    CountryCodeToCurrencyNameMap["NL"] = "EUR";
    /**
     * New Zealand (Dollar)
     */
    CountryCodeToCurrencyNameMap["NZ"] = "NZD";
    /**
     * Poland (Zloty)
     */
    CountryCodeToCurrencyNameMap["PL"] = "PLN";
    /**
     * Portugal (Euro)
     */
    CountryCodeToCurrencyNameMap["PT"] = "EUR";
    /**
     * Romania (Leu)
     */
    CountryCodeToCurrencyNameMap["RO"] = "RON";
    /**
     * Singapore (Dollar)
     */
    CountryCodeToCurrencyNameMap["SG"] = "SGD";
    /**
     * Thailand (Baht)
     */
    CountryCodeToCurrencyNameMap["TH"] = "THB";
    /**
     * Taiwan (Dollar)
     */
    CountryCodeToCurrencyNameMap["TW"] = "TWD";
    /**
     * United States (Dollar)
     */
    CountryCodeToCurrencyNameMap["US"] = "USD";
    /**
     * South Africa (Rand)
     */
    CountryCodeToCurrencyNameMap["ZA"] = "ZAR";
})(CountryCodeToCurrencyNameMap || (exports.CountryCodeToCurrencyNameMap = CountryCodeToCurrencyNameMap = {}));
/**
 * Any valid ISO 3166-1 alpha-3 (3 character) country code
 */
var IsoCountryCode;
(function (IsoCountryCode) {
    /**
     * Antarctica (AQ)
     */
    IsoCountryCode["ATA"] = "ATA";
    /**
     * Austria (AT)
     */
    IsoCountryCode["AUT"] = "AUT";
    /**
     * Canada (CA)
     */
    IsoCountryCode["CAN"] = "CAN";
    /**
     * Switzerland (CH)
     */
    IsoCountryCode["CHE"] = "CHE";
    /**
     * Czech Republic (CZ)
     */
    IsoCountryCode["CZE"] = "CZE";
    /**
     * Germany (DE)
     */
    IsoCountryCode["DEU"] = "DEU";
    /**
     * Spain (ES)
     */
    IsoCountryCode["ESP"] = "ESP";
    /**
     * France (FR)
     */
    IsoCountryCode["FRA"] = "FRA";
    /**
     * United Kingdom (GB)
     */
    IsoCountryCode["GBR"] = "GBR";
    /**
     * Indonesia (ID)
     */
    IsoCountryCode["IDN"] = "IDN";
    /**
     * Japan (JP)
     */
    IsoCountryCode["JPN"] = "JPN";
    /**
     * South Korea (KR)
     */
    IsoCountryCode["KOR"] = "KOR";
    /**
     * Malaysia (MY)
     */
    IsoCountryCode["MYS"] = "MYS";
    /**
     * Netherlands (NL)
     */
    IsoCountryCode["NLD"] = "NLD";
    /**
     * New Zealand (NZ)
     */
    IsoCountryCode["NZL"] = "NZL";
    /**
     * Poland (PL)
     */
    IsoCountryCode["POL"] = "POL";
    /**
     * Portugal (PT)
     */
    IsoCountryCode["PRT"] = "PRT";
    /**
     * Romania (RO)
     */
    IsoCountryCode["ROU"] = "ROU";
    /**
     * Singapore (SG)
     */
    IsoCountryCode["SGP"] = "SGP";
    /**
     * Thailand (TH)
     */
    IsoCountryCode["THA"] = "THA";
    /**
     * Taiwan (TW)
     */
    IsoCountryCode["TWN"] = "TWN";
    /**
     * United States (US)
     */
    IsoCountryCode["USA"] = "USA";
    /**
     * South Africa (ZA)
     */
    IsoCountryCode["ZAF"] = "ZAF";
})(IsoCountryCode || (exports.IsoCountryCode = IsoCountryCode = {}));
/**
 * Any valid ISO 3166-1 alpha-2 (2 character) country code
 */
var IsoCountryCode2Char;
(function (IsoCountryCode2Char) {
    /**
     * Antarctica (ATA)
     */
    IsoCountryCode2Char["AQ"] = "AQ";
    /**
     * Austria (AUT)
     */
    IsoCountryCode2Char["AT"] = "AT";
    /**
     * Canada (CAN)
     */
    IsoCountryCode2Char["CA"] = "CA";
    /**
     * Switzerland (CHE)
     */
    IsoCountryCode2Char["CH"] = "CH";
    /**
     * Czech Republic (CZE)
     */
    IsoCountryCode2Char["CZ"] = "CZ";
    /**
     * Germany (DEU)
     */
    IsoCountryCode2Char["DE"] = "DE";
    /**
     * Spain (ESP)
     */
    IsoCountryCode2Char["ES"] = "ES";
    /**
     * France (FRA)
     */
    IsoCountryCode2Char["FR"] = "FR";
    /**
     * United Kingdom (GBR)
     */
    IsoCountryCode2Char["GB"] = "GB";
    /**
     * Indonesia (IDN)
     */
    IsoCountryCode2Char["ID"] = "ID";
    /**
     * Japan (JPN)
     */
    IsoCountryCode2Char["JP"] = "JP";
    /**
     * South Korea (KOR)
     */
    IsoCountryCode2Char["KR"] = "KR";
    /**
     * Malaysia (MYS)
     */
    IsoCountryCode2Char["MY"] = "MY";
    /**
     * Netherlands (NLD)
     */
    IsoCountryCode2Char["NL"] = "NL";
    /**
     * New Zealand (NZL)
     */
    IsoCountryCode2Char["NZ"] = "NZ";
    /**
     * Poland (POL)
     */
    IsoCountryCode2Char["PL"] = "PL";
    /**
     * Portugal (PRT)
     */
    IsoCountryCode2Char["PT"] = "PT";
    /**
     * Romania (ROU)
     */
    IsoCountryCode2Char["RO"] = "RO";
    /**
     * Singapore (SGP)
     */
    IsoCountryCode2Char["SG"] = "SG";
    /**
     * Thailand (THA)
     */
    IsoCountryCode2Char["TH"] = "TH";
    /**
     * Taiwan (TWN)
     */
    IsoCountryCode2Char["TW"] = "TW";
    /**
     * United States (USA)
     */
    IsoCountryCode2Char["US"] = "US";
    /**
     * South Africa (ZAF)
     */
    IsoCountryCode2Char["ZA"] = "ZA";
})(IsoCountryCode2Char || (exports.IsoCountryCode2Char = IsoCountryCode2Char = {}));
var IsoCountryCodeToCurrencyNameMap;
(function (IsoCountryCodeToCurrencyNameMap) {
    /**
     * Antarctica (ATA)
     */
    IsoCountryCodeToCurrencyNameMap["ATA"] = "USD";
    /**
     * Austria (AUT)
     */
    IsoCountryCodeToCurrencyNameMap["AUT"] = "EUR";
    /**
     * Canada (CAN)
     */
    IsoCountryCodeToCurrencyNameMap["CAN"] = "CAD";
    /**
     * Switzerland (CHE)
     */
    IsoCountryCodeToCurrencyNameMap["CHE"] = "CHF";
    /**
     * Czech Republic (CZE)
     */
    IsoCountryCodeToCurrencyNameMap["CZE"] = "CZK";
    /**
     * Germany (DEU)
     */
    IsoCountryCodeToCurrencyNameMap["DEU"] = "EUR";
    /**
     * Spain (ESP)
     */
    IsoCountryCodeToCurrencyNameMap["ESP"] = "EUR";
    /**
     * France (FRA)
     */
    IsoCountryCodeToCurrencyNameMap["FRA"] = "EUR";
    /**
     * United Kingdom (GBR)
     */
    IsoCountryCodeToCurrencyNameMap["GBR"] = "GBP";
    /**
     * Indonesia (IDN)
     */
    IsoCountryCodeToCurrencyNameMap["IDN"] = "IDR";
    /**
     * Japan (JPN)
     */
    IsoCountryCodeToCurrencyNameMap["JPN"] = "JPY";
    /**
     * South Korea (KOR)
     */
    IsoCountryCodeToCurrencyNameMap["KOR"] = "KRW";
    /**
     * Malaysia (MYS)
     */
    IsoCountryCodeToCurrencyNameMap["MYS"] = "MYR";
    /**
     * Netherlands (NLD)
     */
    IsoCountryCodeToCurrencyNameMap["NLD"] = "EUR";
    /**
     * New Zealand (NZL)
     */
    IsoCountryCodeToCurrencyNameMap["NZL"] = "NZD";
    /**
     * Poland (POL)
     */
    IsoCountryCodeToCurrencyNameMap["POL"] = "PLN";
    /**
     * Portugal (PRT)
     */
    IsoCountryCodeToCurrencyNameMap["PRT"] = "EUR";
    /**
     * Romania (ROU)
     */
    IsoCountryCodeToCurrencyNameMap["ROU"] = "RON";
    /**
     * Singapore (SGP)
     */
    IsoCountryCodeToCurrencyNameMap["SGP"] = "SGD";
    /**
     * Thailand (THA)
     */
    IsoCountryCodeToCurrencyNameMap["THA"] = "THB";
    /**
     * Taiwan (TWN)
     */
    IsoCountryCodeToCurrencyNameMap["TWN"] = "TWD";
    /**
     * United States (USA)
     */
    IsoCountryCodeToCurrencyNameMap["USA"] = "USD";
    /**
     * South Africa (ZAF)
     */
    IsoCountryCodeToCurrencyNameMap["ZAF"] = "ZAR";
})(IsoCountryCodeToCurrencyNameMap || (exports.IsoCountryCodeToCurrencyNameMap = IsoCountryCodeToCurrencyNameMap = {}));
/**
 * All valid locales for money formatting library
 */
var MoneyFormatLocale;
(function (MoneyFormatLocale) {
    MoneyFormatLocale["en-au"] = "en-au";
    MoneyFormatLocale["de-at"] = "de-at";
    MoneyFormatLocale["fr-ch"] = "fr-ch";
    MoneyFormatLocale["cs"] = "cs";
    MoneyFormatLocale["de"] = "de";
    MoneyFormatLocale["es-es"] = "es-es";
    MoneyFormatLocale["fr-fr"] = "fr-fr";
    MoneyFormatLocale["en-gb"] = "en-gb";
    MoneyFormatLocale["id"] = "id";
    MoneyFormatLocale["ja"] = "ja";
    MoneyFormatLocale["ko-kr"] = "ko-kr";
    MoneyFormatLocale["ms-my"] = "ms-my";
    MoneyFormatLocale["nl-nl"] = "nl-nl";
    MoneyFormatLocale["en-nz"] = "en-nz";
    MoneyFormatLocale["pl"] = "pl";
    MoneyFormatLocale["pt-pt"] = "pt-pt";
    MoneyFormatLocale["ro"] = "ro";
    MoneyFormatLocale["cmn"] = "cmn";
    MoneyFormatLocale["th"] = "th";
    MoneyFormatLocale["zh-tw"] = "zh-tw";
    MoneyFormatLocale["en-za"] = "en-za";
})(MoneyFormatLocale || (exports.MoneyFormatLocale = MoneyFormatLocale = {}));
/**
 * Object mapping ISO 3166-1 alpha-2 (2 character) country code to ISO 3166-1 alpha-3 (3 character) country code
 */
exports.countryCodeToIsoCountryCodeMap = {
    [IsoCountryCode2Char.AQ]: IsoCountryCode.ATA,
    [IsoCountryCode2Char.AT]: IsoCountryCode.AUT,
    [IsoCountryCode2Char.CA]: IsoCountryCode.CAN,
    [IsoCountryCode2Char.CH]: IsoCountryCode.CHE,
    [IsoCountryCode2Char.CZ]: IsoCountryCode.CZE,
    [IsoCountryCode2Char.DE]: IsoCountryCode.DEU,
    [IsoCountryCode2Char.ES]: IsoCountryCode.ESP,
    [IsoCountryCode2Char.FR]: IsoCountryCode.FRA,
    [IsoCountryCode2Char.GB]: IsoCountryCode.GBR,
    [IsoCountryCode2Char.ID]: IsoCountryCode.IDN,
    [IsoCountryCode2Char.JP]: IsoCountryCode.JPN,
    [IsoCountryCode2Char.KR]: IsoCountryCode.KOR,
    [IsoCountryCode2Char.MY]: IsoCountryCode.MYS,
    [IsoCountryCode2Char.NL]: IsoCountryCode.NLD,
    [IsoCountryCode2Char.NZ]: IsoCountryCode.NZL,
    [IsoCountryCode2Char.PL]: IsoCountryCode.POL,
    [IsoCountryCode2Char.PT]: IsoCountryCode.PRT,
    [IsoCountryCode2Char.RO]: IsoCountryCode.ROU,
    [IsoCountryCode2Char.SG]: IsoCountryCode.SGP,
    [IsoCountryCode2Char.TH]: IsoCountryCode.THA,
    [IsoCountryCode2Char.TW]: IsoCountryCode.TWN,
    [IsoCountryCode2Char.US]: IsoCountryCode.USA,
    [IsoCountryCode2Char.ZA]: IsoCountryCode.ZAF,
};
/**
 * Record mapping ISO 3166-1 alpha-2 (2 character) country code to ISO 3166-1 alpha-3 (3 character) country code
 */
exports.ISO2_ISO_MAPPING = {
    [IsoCountryCode2Char.AQ]: IsoCountryCode.ATA,
    [IsoCountryCode2Char.AT]: IsoCountryCode.AUT,
    [IsoCountryCode2Char.CA]: IsoCountryCode.CAN,
    [IsoCountryCode2Char.CH]: IsoCountryCode.CHE,
    [IsoCountryCode2Char.CZ]: IsoCountryCode.CZE,
    [IsoCountryCode2Char.DE]: IsoCountryCode.DEU,
    [IsoCountryCode2Char.ES]: IsoCountryCode.ESP,
    [IsoCountryCode2Char.FR]: IsoCountryCode.FRA,
    [IsoCountryCode2Char.GB]: IsoCountryCode.GBR,
    [IsoCountryCode2Char.ID]: IsoCountryCode.IDN,
    [IsoCountryCode2Char.JP]: IsoCountryCode.JPN,
    [IsoCountryCode2Char.KR]: IsoCountryCode.KOR,
    [IsoCountryCode2Char.MY]: IsoCountryCode.MYS,
    [IsoCountryCode2Char.NL]: IsoCountryCode.NLD,
    [IsoCountryCode2Char.NZ]: IsoCountryCode.NZL,
    [IsoCountryCode2Char.PL]: IsoCountryCode.POL,
    [IsoCountryCode2Char.PT]: IsoCountryCode.PRT,
    [IsoCountryCode2Char.RO]: IsoCountryCode.ROU,
    [IsoCountryCode2Char.SG]: IsoCountryCode.SGP,
    [IsoCountryCode2Char.TH]: IsoCountryCode.THA,
    [IsoCountryCode2Char.TW]: IsoCountryCode.TWN,
    [IsoCountryCode2Char.US]: IsoCountryCode.USA,
    [IsoCountryCode2Char.ZA]: IsoCountryCode.ZAF,
};
/**
 * Record mapping ISO 3166-1 alpha-3 (3 character) country code to ISO 3166-1 alpha-2 (2 character) country code
 */
exports.ISO_ISO2_MAPPING = {
    [IsoCountryCode.ATA]: IsoCountryCode2Char.AQ,
    [IsoCountryCode.AUT]: IsoCountryCode2Char.AT,
    [IsoCountryCode.CAN]: IsoCountryCode2Char.CA,
    [IsoCountryCode.CHE]: IsoCountryCode2Char.CH,
    [IsoCountryCode.CZE]: IsoCountryCode2Char.CZ,
    [IsoCountryCode.DEU]: IsoCountryCode2Char.DE,
    [IsoCountryCode.ESP]: IsoCountryCode2Char.ES,
    [IsoCountryCode.FRA]: IsoCountryCode2Char.FR,
    [IsoCountryCode.GBR]: IsoCountryCode2Char.GB,
    [IsoCountryCode.IDN]: IsoCountryCode2Char.ID,
    [IsoCountryCode.JPN]: IsoCountryCode2Char.JP,
    [IsoCountryCode.KOR]: IsoCountryCode2Char.KR,
    [IsoCountryCode.MYS]: IsoCountryCode2Char.MY,
    [IsoCountryCode.NLD]: IsoCountryCode2Char.NL,
    [IsoCountryCode.NZL]: IsoCountryCode2Char.NZ,
    [IsoCountryCode.POL]: IsoCountryCode2Char.PL,
    [IsoCountryCode.PRT]: IsoCountryCode2Char.PT,
    [IsoCountryCode.ROU]: IsoCountryCode2Char.RO,
    [IsoCountryCode.SGP]: IsoCountryCode2Char.SG,
    [IsoCountryCode.THA]: IsoCountryCode2Char.TH,
    [IsoCountryCode.TWN]: IsoCountryCode2Char.TW,
    [IsoCountryCode.USA]: IsoCountryCode2Char.US,
    [IsoCountryCode.ZAF]: IsoCountryCode2Char.ZA,
};
/**
 * Maps an upper case country name to the ISO 3166-1 alpha-2 (2 character) country code
 */
exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED = {
    ['ANTARCTICA']: IsoCountryCode2Char.AQ,
    ['AUSTRIA']: IsoCountryCode2Char.AT,
    ['CANADA']: IsoCountryCode2Char.CA,
    ['CZECH REPUBLIC']: IsoCountryCode2Char.CZ,
    ['FRANCE']: IsoCountryCode2Char.FR,
    ['GERMANY']: IsoCountryCode2Char.DE,
    ['INDONESIA']: IsoCountryCode2Char.ID,
    ['JAPAN']: IsoCountryCode2Char.JP,
    ['MALAYSIA']: IsoCountryCode2Char.MY,
    ['NETHERLANDS']: IsoCountryCode2Char.NL,
    ['NEW ZEALAND']: IsoCountryCode2Char.NZ,
    ['POLAND']: IsoCountryCode2Char.PL,
    ['PORTUGAL']: IsoCountryCode2Char.PT,
    ['ROMANIA']: IsoCountryCode2Char.RO,
    ['SINGAPORE']: IsoCountryCode2Char.SG,
    ['SOUTH AFRICA']: IsoCountryCode2Char.ZA,
    ['SOUTH KOREA']: IsoCountryCode2Char.KR,
    ['SPAIN']: IsoCountryCode2Char.ES,
    ['SWITZERLAND']: IsoCountryCode2Char.CH,
    ['TAIWAN']: IsoCountryCode2Char.TW,
    ['THAILAND']: IsoCountryCode2Char.TH,
    ['UNITED KINGDOM']: IsoCountryCode2Char.GB,
    ['UNITED STATES']: IsoCountryCode2Char.US,
};
/**
 * Money format locale for given country
 *
 * @todo Use a different mechanism for currency formatting
 * @see https://rbictg.atlassian.net/wiki/spaces/IN/pages/3081371649/Email+currencies
 */
exports.ISO2_CURRENCY_FORMATTER_MAPPING = {
    [IsoCountryCode2Char.AQ]: (0, money_1.toDollar)(MoneyFormatLocale['en-au']),
    [IsoCountryCode2Char.AT]: (0, money_1.toDollar)(MoneyFormatLocale['de-at']),
    [IsoCountryCode2Char.CA]: (0, money_1.toDollar)(MoneyFormatLocale['en-au']),
    [IsoCountryCode2Char.CH]: (0, money_1.toDollar)(MoneyFormatLocale['fr-ch']),
    [IsoCountryCode2Char.CZ]: (0, money_1.toDollar)(MoneyFormatLocale['cs']),
    [IsoCountryCode2Char.DE]: (0, money_1.toDollar)(MoneyFormatLocale['de']),
    [IsoCountryCode2Char.ES]: (0, money_1.toDollar)(MoneyFormatLocale['es-es']),
    [IsoCountryCode2Char.FR]: (0, money_1.toDollar)(MoneyFormatLocale['fr-fr']),
    [IsoCountryCode2Char.GB]: (0, money_1.toDollar)(MoneyFormatLocale['en-gb']),
    [IsoCountryCode2Char.ID]: (0, money_1.toDollar)(MoneyFormatLocale['id']),
    [IsoCountryCode2Char.JP]: (0, money_1.toDollar)(MoneyFormatLocale['ja']),
    [IsoCountryCode2Char.KR]: (0, money_1.toDollar)(MoneyFormatLocale['ko-kr']),
    [IsoCountryCode2Char.MY]: (0, money_1.toDollar)(MoneyFormatLocale['ms-my']),
    [IsoCountryCode2Char.NL]: (0, money_1.toDollar)(MoneyFormatLocale['nl-nl']),
    [IsoCountryCode2Char.NZ]: (0, money_1.toDollar)(MoneyFormatLocale['en-nz']),
    [IsoCountryCode2Char.PL]: (0, money_1.toDollar)(MoneyFormatLocale['pl']),
    [IsoCountryCode2Char.PT]: (0, money_1.toDollar)(MoneyFormatLocale['pt-pt']),
    [IsoCountryCode2Char.RO]: (0, money_1.toDollar)(MoneyFormatLocale['ro']),
    [IsoCountryCode2Char.SG]: (0, money_1.toDollar)(MoneyFormatLocale['cmn']),
    [IsoCountryCode2Char.TH]: (0, money_1.toDollar)(MoneyFormatLocale['th']),
    [IsoCountryCode2Char.TW]: (0, money_1.toDollar)(MoneyFormatLocale['zh-tw']),
    [IsoCountryCode2Char.US]: (0, money_1.toDollar)(MoneyFormatLocale['en-au']),
    [IsoCountryCode2Char.ZA]: (0, money_1.toDollar)(MoneyFormatLocale['en-za']),
};
/**
 * Map a country identifier to its ISO 3166-1 numeric code.
 *
 * Allowed inputs:
 * - Country name (title case)
 * - Country name (upper case)
 * - Country name (lower case)
 * - ISO 3166-1 alpha-2 (2 character) country code (lower case)
 * - ISO 3166-1 alpha-2 (2 character) country code (upper case)
 * - ISO 3166-1 alpha-3 (3 character) country code (lower case)
 * - ISO 3166-1 alpha-3 (3 character) country code (upper case)
 *
 * Meant to handle different input shapes since input comes from sanity
 */
exports.storeCountryToCurrencyCodeMapGenerated = {
    ['ANTARCTICA']: 840,
    ['AQ']: 840,
    ['AT']: 978,
    ['ATA']: 840,
    ['AUSTRIA']: 978,
    ['AUT']: 978,
    ['Antarctica']: 840,
    ['Austria']: 978,
    ['CA']: 124,
    ['CAN']: 124,
    ['CANADA']: 124,
    ['CH']: 756,
    ['CHE']: 756,
    ['CZ']: 203,
    ['CZE']: 203,
    ['CZECH REPUBLIC']: 203,
    ['Canada']: 124,
    ['Czech Republic']: 203,
    ['DE']: 978,
    ['DEU']: 978,
    ['ES']: 978,
    ['ESP']: 978,
    ['FR']: 978,
    ['FRA']: 978,
    ['FRANCE']: 978,
    ['France']: 978,
    ['GB']: 826,
    ['GBR']: 826,
    ['GERMANY']: 978,
    ['Germany']: 978,
    ['ID']: 360,
    ['IDN']: 360,
    ['INDONESIA']: 360,
    ['Indonesia']: 360,
    ['JAPAN']: 392,
    ['JP']: 392,
    ['JPN']: 392,
    ['Japan']: 392,
    ['KOR']: 410,
    ['KR']: 410,
    ['MALAYSIA']: 458,
    ['MY']: 458,
    ['MYS']: 458,
    ['Malaysia']: 458,
    ['NETHERLANDS']: 978,
    ['NEW ZEALAND']: 554,
    ['NL']: 978,
    ['NLD']: 978,
    ['NZ']: 554,
    ['NZL']: 554,
    ['Netherlands']: 978,
    ['New Zealand']: 554,
    ['PL']: 985,
    ['POL']: 985,
    ['POLAND']: 985,
    ['PORTUGAL']: 978,
    ['PRT']: 978,
    ['PT']: 978,
    ['Poland']: 985,
    ['Portugal']: 978,
    ['RO']: 946,
    ['ROMANIA']: 946,
    ['ROU']: 946,
    ['Romania']: 946,
    ['SG']: 702,
    ['SGP']: 702,
    ['SINGAPORE']: 702,
    ['SOUTH AFRICA']: 710,
    ['SOUTH KOREA']: 410,
    ['SPAIN']: 978,
    ['SWITZERLAND']: 756,
    ['Singapore']: 702,
    ['South Africa']: 710,
    ['South Korea']: 410,
    ['Spain']: 978,
    ['Switzerland']: 756,
    ['TAIWAN']: 901,
    ['TH']: 764,
    ['THA']: 764,
    ['THAILAND']: 764,
    ['TW']: 901,
    ['TWN']: 901,
    ['Taiwan']: 901,
    ['Thailand']: 764,
    ['UNITED KINGDOM']: 826,
    ['UNITED STATES']: 840,
    ['US']: 840,
    ['USA']: 840,
    ['United Kingdom']: 826,
    ['United States']: 840,
    ['ZA']: 710,
    ['ZAF']: 710,
    ['antarctica']: 840,
    ['aq']: 840,
    ['at']: 978,
    ['ata']: 840,
    ['austria']: 978,
    ['aut']: 978,
    ['ca']: 124,
    ['can']: 124,
    ['canada']: 124,
    ['ch']: 756,
    ['che']: 756,
    ['cz']: 203,
    ['cze']: 203,
    ['czech republic']: 203,
    ['de']: 978,
    ['deu']: 978,
    ['es']: 978,
    ['esp']: 978,
    ['fr']: 978,
    ['fra']: 978,
    ['france']: 978,
    ['gb']: 826,
    ['gbr']: 826,
    ['germany']: 978,
    ['id']: 360,
    ['idn']: 360,
    ['indonesia']: 360,
    ['japan']: 392,
    ['jp']: 392,
    ['jpn']: 392,
    ['kor']: 410,
    ['kr']: 410,
    ['malaysia']: 458,
    ['my']: 458,
    ['mys']: 458,
    ['netherlands']: 978,
    ['new zealand']: 554,
    ['nl']: 978,
    ['nld']: 978,
    ['nz']: 554,
    ['nzl']: 554,
    ['pl']: 985,
    ['pol']: 985,
    ['poland']: 985,
    ['portugal']: 978,
    ['prt']: 978,
    ['pt']: 978,
    ['ro']: 946,
    ['romania']: 946,
    ['rou']: 946,
    ['sg']: 702,
    ['sgp']: 702,
    ['singapore']: 702,
    ['south africa']: 710,
    ['south korea']: 410,
    ['spain']: 978,
    ['switzerland']: 756,
    ['taiwan']: 901,
    ['th']: 764,
    ['tha']: 764,
    ['thailand']: 764,
    ['tw']: 901,
    ['twn']: 901,
    ['united kingdom']: 826,
    ['united states']: 840,
    ['us']: 840,
    ['usa']: 840,
    ['za']: 710,
    ['zaf']: 710,
};
/**
 * Maps brand to supported regions
 */
exports.BRAND_TO_SUPPORTED_REGIONS_MAPPING = {
    [brand_1.Brand.BK]: [
        IsoCountryCode2Char.CA,
        IsoCountryCode2Char.CH,
        IsoCountryCode2Char.DE,
        IsoCountryCode2Char.GB,
        IsoCountryCode2Char.NZ,
        IsoCountryCode2Char.US,
        IsoCountryCode2Char.ZA,
        IsoCountryCode2Char.NL,
        IsoCountryCode2Char.AQ,
        IsoCountryCode2Char.PT,
        IsoCountryCode2Char.AT,
        IsoCountryCode2Char.CZ,
        IsoCountryCode2Char.PL,
        IsoCountryCode2Char.RO,
        IsoCountryCode2Char.ES,
        IsoCountryCode2Char.CH,
        IsoCountryCode2Char.GB,
        IsoCountryCode2Char.ZA,
    ],
    [brand_1.Brand.LTW]: [IsoCountryCode2Char.US],
    [brand_1.Brand.PLK]: [
        IsoCountryCode2Char.CA,
        IsoCountryCode2Char.CH,
        IsoCountryCode2Char.US,
        IsoCountryCode2Char.KR,
        IsoCountryCode2Char.ES,
        IsoCountryCode2Char.FR,
        IsoCountryCode2Char.PT,
        IsoCountryCode2Char.SG,
        IsoCountryCode2Char.CZ,
        IsoCountryCode2Char.PL,
        IsoCountryCode2Char.NZ,
        IsoCountryCode2Char.TW,
        IsoCountryCode2Char.TH,
        IsoCountryCode2Char.AQ,
        IsoCountryCode2Char.CH,
    ],
    [brand_1.Brand.TH]: [
        IsoCountryCode2Char.CA,
        IsoCountryCode2Char.US,
        IsoCountryCode2Char.ES,
        IsoCountryCode2Char.MY,
        IsoCountryCode2Char.ID,
        IsoCountryCode2Char.KR,
        IsoCountryCode2Char.JP,
        IsoCountryCode2Char.TW,
        IsoCountryCode2Char.AQ,
    ],
    [brand_1.Brand.FHS]: [
        IsoCountryCode2Char.US,
        IsoCountryCode2Char.CA,
        IsoCountryCode2Char.CH,
        IsoCountryCode2Char.AQ,
    ],
};
//# sourceMappingURL=generated.js.map